import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Stack,
  Paper,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { ENDPOINT, IMAGE_BASE_URL } from "../../../endpoints/endpoints";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import dayjs from "dayjs";

const OddsUpdate = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    league_id: "",
    home_team_id: "",
    away_team_id: "",
    match_time: dayjs(),
    body_odds: "",
    over_under_odds: "",
    body_odds_team: "",
    home_score: "",
    away_score: "",
    is_finished: ""
  });

  const token = localStorage.getItem("accessToken");

  const [loading, setLoading] = useState(false);

  // ==== League Data ====
  const [leagues, setLeagues] = useState([]);
  const [leagueSearch, setLeagueSearch] = useState("");
  const [filteredLeagues, setfilteredleague] = useState([]);

  const [teams, setTeams] = useState([]);
  const [teamSearch, setTeamSearch] = useState("");
  const [filteredTeams, setfilteredteam] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    if (!token) {
      toast.warning("Please log in to continue");
      navigate("/login");
    } else {
      fetchAllLeagues();
      fetchAllTeam();
      fetchDetail()
    }
  }, [navigate]);

  const fetchAllLeagues = async () => {
    try {
      let url = ENDPOINT.LEAGUECATEGORY_LIST;
      let allResults = [];

      while (url) {
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        allResults = [...allResults, ...res.data.results];
        url = res.data.next; // load next pages
      }

      setLeagues(allResults);
      setfilteredleague(allResults)
    } catch (error) {
      console.error("Error loading league list:", error);
      toast.error("Failed to load leagues");
    }
  };

  const fetchAllTeam = async () => {
    try {
      let url = ENDPOINT.TEAM_LIST;
      let allResults = [];

      while (url) {
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        allResults = [...allResults, ...res.data.results];
        url = res.data.next; // load next pages
      }

      setTeams(allResults);
      setfilteredteam(allResults)
    } catch (error) {
      console.error("Error loading team list:", error);
      toast.error("Failed to load teams");
    }
  };

  useEffect(() => {
    let filteredLeague = leagues.filter((l) =>
      l.name.toLowerCase().includes(leagueSearch.toLowerCase())
    );
    setfilteredleague(filteredLeague)
  }, [leagueSearch])

  useEffect(() => {
    let filteredTeam = teams.filter((t) =>
      t.name.toLowerCase().includes(teamSearch.toLowerCase())
    );
    setfilteredteam(filteredTeam)
  }, [teamSearch])

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const fetchDetail = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("accessToken");

      const res = await axios.get(ENDPOINT.ODDS_DETAIL(id), {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = res.data.data

      setFormData({
        league_id: data.league?.id || "",
        home_team_id: data.home_team_id || "",
        away_team_id: data.away_team_id || "",
        match_time: dayjs(data.match_time),
        body_odds: data.body_odds || "",
        body_odds_team: data.body_odds_team || "",
        over_under_odds: data.over_under_odds || "",
        home_score: data.home_score ?? 0,
        away_score: data.away_score ?? 0,
        is_finished: Boolean(data.is_finished),
      });

    } catch (err) {
      toast.error("Failed to fetch table detail");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!token) {
        toast.error("You must log in first!");
        navigate("/login");
        return;
      }

      const data = new FormData();
      Object.keys(formData).forEach((key) => {
        if (key === "match_time") {
          data.append(key, formData[key].toISOString());
        } else {
          data.append(key, formData[key]);
        }
      });

      const response = await axios.put(ENDPOINT.ODDS_UPDATE(id), data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "muloddart/form-data",
        },
      });

      const msg = response.data.message || "Odd updated successfully";

      toast.success(msg);
      setTimeout(() => navigate(`/odds/list`), 1200);
    } catch (err) {
      console.error("Error updating Odd:", err);
      toast.error(
        err.response?.data?.message ||
        err.response?.data?.detail ||
        "Something went wrong."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 5, mb: 5 }}>
      <ToastContainer position="top-right" autoClose={3000} />

      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h5" fontWeight={600} mb={3}>
          🖼 Update Odd
        </Typography>

        <form onSubmit={handleSubmit} encType="muloddart/form-data">
          <Stack spacing={2}>

            <FormControl fullWidth>
              <InputLabel id="league-label">League</InputLabel>

              <Select
                labelId="league-label"
                label="League"
                name="league_id"
                value={formData.league_id}
                onChange={handleChange}
                required
                MenuProps={{ PaperProps: { style: { maxHeight: 350 } } }}
              >
                {/* Search Box */}
                <MenuItem disableRipple>
                  <TextField
                    fullWidth
                    placeholder="Search league..."
                    size="small"
                    value={leagueSearch}
                    onChange={(e) => setLeagueSearch(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()}
                  />
                </MenuItem>

                <MenuItem disabled>
                  <Typography variant="caption" color="text.secondary">
                    {filteredLeagues.length} results
                  </Typography>
                </MenuItem>

                {filteredLeagues.map((l) => (
                  <MenuItem key={l.id} value={l.id}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        component="img"
                        src={`${IMAGE_BASE_URL}${l.image}`}
                        alt={l.name}
                        sx={{
                          width: 28,
                          height: 28,
                          borderRadius: "50%",
                          mr: 1.5,
                        }}
                      />
                      {l.name}
                    </Box>
                  </MenuItem>
                ))}

                {filteredLeagues.length === 0 && (
                  <MenuItem disabled>No results found</MenuItem>
                )}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="hometeam-label">Home Team</InputLabel>

              <Select
                labelId="hometeam-label"
                label="League"
                name="home_team_id"
                value={formData.home_team_id}
                onChange={handleChange}
                required
                MenuProps={{ PaperProps: { style: { maxHeight: 350 } } }}
              >
                {/* Search Box */}
                <MenuItem disableRipple>
                  <TextField
                    fullWidth
                    placeholder="Search Team ..."
                    size="small"
                    value={teamSearch}
                    onChange={(e) => setTeamSearch(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()}
                  />
                </MenuItem>

                <MenuItem disabled>
                  <Typography variant="caption" color="text.secondary">
                    {filteredTeams.length} results
                  </Typography>
                </MenuItem>

                {filteredTeams.map((t) => (
                  <MenuItem key={t.id} value={t.id}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        component="img"
                        src={`${IMAGE_BASE_URL}${t.image}`}
                        alt={t.name}
                        sx={{
                          width: 28,
                          height: 28,
                          borderRadius: "50%",
                          mr: 1.5,
                        }}
                      />
                      {t.name}
                    </Box>
                  </MenuItem>
                ))}

                {filteredTeams.length === 0 && (
                  <MenuItem disabled>No results found</MenuItem>
                )}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="awayteam-label">Away Team</InputLabel>

              <Select
                labelId="awayteam-label"
                label="Team 2"
                name="away_team_id"
                value={formData.away_team_id}
                onChange={handleChange}
                required
                MenuProps={{ PaperProps: { style: { maxHeight: 350 } } }}
              >
                {/* Search Box */}
                <MenuItem disableRipple>
                  <TextField
                    fullWidth
                    placeholder="Search team 2..."
                    size="small"
                    value={teamSearch}
                    onChange={(e) => setTeamSearch(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()}
                  />
                </MenuItem>

                <MenuItem disabled>
                  <Typography variant="caption" color="text.secondary">
                    {filteredTeams.length} results
                  </Typography>
                </MenuItem>

                {filteredTeams.map((t) => (
                  <MenuItem key={t.id} value={t.id}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        component="img"
                        src={`${IMAGE_BASE_URL}${t.image}`}
                        alt={t.name}
                        sx={{
                          width: 28,
                          height: 28,
                          borderRadius: "50%",
                          mr: 1.5,
                        }}
                      />
                      {t.name}
                    </Box>
                  </MenuItem>
                ))}

                {filteredTeams.length === 0 && (
                  <MenuItem disabled>No results found</MenuItem>
                )}
              </Select>
            </FormControl>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker
                label="Date & Time"
                value={formData.match_time}
                onChange={(newValue) =>
                  setFormData((prev) => ({ ...prev, match_time: newValue }))
                }
                slotProps={{
                  textField: {
                    name: "match_time",
                    required: true,
                    fullWidth: true,
                  },
                }}
              />
            </LocalizationProvider>

            <TextField
              label="Body Odds"
              name="body_odds"
              value={formData.body_odds}
              onChange={handleChange}
              fullWidth
            />
            <FormControl fullWidth required>
              <InputLabel id="body-odds-team-label">
                Body Odds Team
              </InputLabel>

              <Select
                labelId="body-odds-team-label"
                label="Body Odds Team"
                name="body_odds_team"
                value={formData.body_odds_team}
                onChange={handleChange}
              >
                <MenuItem value="HOME">Home Team</MenuItem>
                <MenuItem value="AWAY">Away Team</MenuItem>
              </Select>
            </FormControl>


            <TextField
              label="Over Under Odd"
              name="over_under_odds"
              value={formData.over_under_odds}
              onChange={handleChange}
              fullWidth
            />

            <TextField
              label="Home Team Score"
              name="home_score"
              value={formData.home_score}
              onChange={handleChange}
              fullWidth
            />

            <TextField
              label="Away Team Score"
              name="away_score"
              value={formData.away_score}
              onChange={handleChange}
              fullWidth
            />

            <FormControlLabel
              label="Is Finished"
              control={
                <Checkbox
                  name="is_finished"
                  checked={Boolean(formData.is_finished)}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      is_finished: e.target.checked ? true : false,
                    })
                  }
                />
              }
            />

            {/* Submit Button */}
            <Box textAlign="right" mt={2}>
              <Button
                type="submit"
                variant="contained"
                color="success"
                disabled={loading}
                sx={{ px: 4 }}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Update Odd"
                )}
              </Button>
            </Box>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
};

export default OddsUpdate;
